module.exports = __webpack_public_path__ + "static/media/orbita-sydle-one.5b1a0778.svg";